// Payslip delivery status and completion messages (en).
window.PlummeI18n.register('en', {
  'err.payslip.notAuthorized': 'You do not have access to this payslip delivery request.',
  'err.payslip.approvedRunRequired': 'Approve payroll before queueing payslips for its employees.',
  'err.payslip.queueTooLarge': 'The payslip data is too large to queue. Contact support.',
  'pay.payslipSent': 'Payslip sent.',
  'pay.payslipsSent': 'Payslips sent.',
  'pay.payslipsSentAndPosted': 'Payslips sent and payroll posted.',
  'pay.payslipsQueuedAndPosted': 'Payroll posted. Payslips queued for background delivery.',
  'pay.payslipQueued': 'Queued for delivery',
  'pay.payslipsQueued': 'Payslips queued for delivery.',
  'pay.payslipGenerated': 'Generated',
  'pay.payslipNotReady': 'Not ready',
  'pay.payslipScheduled': 'Scheduled',
});
